<template>
  <div class="ra-authx">
    <div class="ra-authx__sidebar">
      <div class="product-label">
        <div class="name">
          <span @click="goToAuthX">
            <i class="ra-icon--arrow-left" />
          </span>
          <p>{{ app }}</p>
        </div>
        <div class="status">
          <el-tag
            v-if="app"
            :type="appStatus ? 'success' : 'danger'"
            size="mini"
            effect="dark"
            >{{ appStatus ? "Active" : "Inactive" }}</el-tag
          >
        </div>
      </div>
      <div class="ra-sidebar__menu">
        <el-menu :default-active="menu" :router="true">
          <template v-for="(route, index) in appRoutes">
            <el-menu-item
              v-if="route.activeRoute"
              :id="`ra-item-${route.name}`"
              :key="index"
              :index="route.name"
              :route="{ name: `authx.apps.${route.name}` }"
            >
              <i :class="`ra-icon--${route.icon}`"></i>
              <span>{{ route.label }}</span>
            </el-menu-item>
          </template>
        </el-menu>
      </div>
      <div class="ra-app__fund"></div>
    </div>
    <div class="ra-authx__content">
      <el-container>
        <ra-breadcrumb :routes="breadcrumbRoutes" />
        <transition name="fade" mode="out-in">
          <router-view />
        </transition>
      </el-container>
    </div>
  </div>
</template>

<script>
import * as mutations from "@/store/mutation-types";

export default {
  name: "AuthxAppLayout",
  data() {
    return {
      menu: "overview",
      appRoutes: [
        {
          icon: "pie-chart",
          label: "Overview",
          name: "overview",
          activeRoute: true
        },
        {
          icon: "settings",
          label: "Configuration",
          name: "configuration",
          activeRoute: true
        },
        {
          icon: "code",
          label: "Integration",
          name: "integration",
          activeRoute: true
        },
        {
          icon: "users",
          label: "Users",
          name: "users",
          activeRoute: true
        },
        {
          icon: "list",
          label: "Logs",
          name: "logs",
          activeRoute: false
        }
      ]
    };
  },
  computed: {
    app() {
      const { name } = this.$store.getters.authx_app;
      return name || "";
    },
    appStatus() {
      return this.$store.getters.authx_app.status_id === 1;
    },
    breadcrumbRoutes() {
      const { matched } = this.$route;
      let routes = matched.map(route => {
        return {
          path: route.path || null,
          label: route.meta.label
        };
      });
      routes.splice(2, 0, {
        path: `/authx/apps/${this.$route.params.id}/overview`,
        label: this.$store.getters.authx_app.name
      });
      routes.splice(0, 0, {
        path: "/home",
        label: "Home"
      });
      routes[2].path = "/authx/overview";
      return routes;
    }
  },
  watch: {
    $route() {
      if (this.$route.path !== null) {
        this.menu = this.$route.name.split(".")[2];
      }
    }
  },
  mounted() {
    if (this.$route.path !== null) {
      this.menu = this.$route.name.split(".")[2];
    }
  },
  methods: {
    goToAuthX() {
      this.$router.push({ name: "authx.index" });
    }
  },
  beforeDestroy() {
    this.$store.commit(mutations.SET_AUTHX_APP, {});
  }
};
</script>

<style lang="scss">
$--sidebar: 190px;

.ra-authx {
  height: 100vh;
  width: 100%;
  position: relative;
  display: flex;
  align-items: center;

  &__sidebar {
    width: $--sidebar;
    height: 100%;
    background: var(--ra-app-sidebar);
    padding: 25px 11px 20px;
    z-index: 4;
    position: relative;
    transition: width 0.3s ease-in;

    .product-label {
      .name {
        display: flex;
        align-items: flex-start;
        margin-bottom: 5px;

        p {
          color: #ffffff;
          font-weight: 600;
          font-size: 0.75rem;
          text-transform: uppercase;
          letter-spacing: 1.5px;
          line-height: 2;
        }

        span {
          cursor: pointer;
          margin-right: 15px;
          position: relative;
          top: 2px;

          i {
            color: #ffffff;
            font-size: 0.875rem;
          }
        }
      }

      .status {
        margin-left: 25px;
      }
    }
  }

  .ra-sidebar__menu {
    .el-menu .el-menu-item.is-active {
      background: var(--ra-product-sidebar) !important;
    }
  }

  &__content {
    height: 100vh;
    overflow: hidden;
    overflow-y: scroll;
    width: calc(100% - #{$--sidebar});
    background: #f5f5f5;
    position: relative;

    > .el-container {
      min-height: calc(100vh - 150px);
      height: 100%;
      padding: 30px;
    }
  }
}

.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.25s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}

//@media (max-width: 1024px) {
//  .ra {
//    .ra-sidebar {
//      position: absolute;
//      left: 0;
//      transition: width 0.3s ease-in;
//      z-index: 4;
//
//      &.open {
//        + .ra-overlay {
//          opacity: 1;
//          z-index: 3;
//          transition: opacity 0.3s ease-out;
//        }
//      }
//    }
//
//    .ra-dashboard--body {
//      width: 100% !important;
//
//      &__content {
//        padding-left: 130px !important;
//      }
//    }
//  }
//}
//
//@media (max-width: 600px) {
//  .ra {
//    .ra-dashboard--body {
//      &__nav {
//        .ra-user p {
//          display: none;
//        }
//      }
//      &__content {
//        padding-left: 100px !important;
//        padding-right: 0 !important;
//      }
//    }
//  }
//}
</style>
